'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getType = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getType = exports.getType = (0, _getIn2.default)(_keyPaths.TYPE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/routing-rules/operators/getType.js
// module id = 920
// module chunks = 2 3